import { render, staticRenderFns } from "./patient.vue?vue&type=template&id=4cc052da&"
import script from "./patient.vue?vue&type=script&lang=js&"
export * from "./patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports